import React from "react";
import { ConfirmationModal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { ProductAccessibilityEnum } from "../types/Api";
export var ProductAccessibilityConfirmModal = function (_a) {
    var open = _a.open, productName = _a.productName, pendingAccessibility = _a.pendingAccessibility, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(ConfirmationModal, { open: open, heading: formatMessage({
            id: pendingAccessibility === ProductAccessibilityEnum.PUBLIC
                ? "ui-br-agency.product.makePublic.modal.heading"
                : "ui-br-agency.product.makePrivate.modal.heading",
        }), message: formatMessage({
            id: pendingAccessibility === ProductAccessibilityEnum.PUBLIC
                ? "ui-br-agency.product.makePublic.confirm"
                : "ui-br-agency.product.makePrivate.confirm",
        }, { name: productName }), onConfirm: onConfirm, onCancel: onCancel, confirmLabel: formatMessage({
            id: "ui-br-agency.button.confirm",
        }), cancelLabel: formatMessage({
            id: "ui-br-agency.button.cancel",
        }), buttonStyle: "primary" }));
};
